import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { AdUnitViewabilityToolsAlert } from 'features/globalSetup/api/types/adUnitViewabilityToolsAlert'
import { floatPercentFromDTO } from 'utils/number'
import { AdUnitViewabilityTools } from '../../types/AdUnitViewabilityTools'
import { AdUnitViewabilityToolsDTO } from '../types/adUnitViewabilityToolsDTO'

type From = AdUnitViewabilityToolsDTO
type To = AdUnitViewabilityTools

export const adUnitViewabilityToolsFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((auvtDTO: From): To => {
    const { createdAt, fieldAlerts, gamAdRequestMargin, kvTargetingAndPrebidAuction, updatedAt } =
      auvtDTO

    return {
      ...auvtDTO,
      alerts: alertsFromDTO<AdUnitViewabilityToolsAlert>(fieldAlerts),
      createdAt: new Date(createdAt),
      gamAdRequestMargin: floatPercentFromDTO(gamAdRequestMargin),
      kvTargetingAndPrebidAuction: floatPercentFromDTO(kvTargetingAndPrebidAuction),
      updatedAt: new Date(updatedAt),
    }
  })
